import { render, staticRenderFns } from "./mailTemplate.vue?vue&type=template&id=21c567d1&scoped=true&"
import script from "./mailTemplate.vue?vue&type=script&lang=js&"
export * from "./mailTemplate.vue?vue&type=script&lang=js&"
import style0 from "./mailTemplate.vue?vue&type=style&index=0&id=21c567d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c567d1",
  null
  
)

export default component.exports